<template>
  <u-modal ref="modal" class="v-modal" v-model="display" :title="title" :footer="typeof $slots.footer !== 'undefined'" :before-close="beforeClose" @show="onShow" @hide="onHide">
    <slot></slot>
    <template slot="footer">
      <a class="btn btn-main btn-wide" @click="display = false">
        <slot name="footer" />
      </a>
    </template>
  </u-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    target: {
      type: String,
      required: false
    },
    targetClass: {
      type: String,
      required: false
    }
  },
  data: function () {
    return {
      display: false
    }
  },
  mounted () {
    var vm = this

    $(window).resize(function () { // resize close modal
      vm.display = false
    })

    if (vm.targetClass) { // add target-class to style
      $(vm.$refs.modal.$el).addClass(vm.targetClass)
      $(vm.$refs.modal.backdrop).addClass(this.targetClass)
    }

    if (vm.target) { // target register event
      $(vm.target).on('click', function () {
        vm.$emit('beforeOpen')
        vm.display = true
      })
    }
  },
  watch: {
    value: function (newValue) {
      var vm = this
      vm.display = newValue // sync prop to data
    },
    display: function (newValue) {
      var vm = this
      vm.$emit('input', newValue) // when modal close, emit parent v-model

      if (newValue && vm.mobile) {
        vm.$nextTick(function () {
          var $el = $(vm.$el)

          var $content = $el.find('.modal-content')
          var borderHeight = $content.outerHeight() - $content.innerHeight()
          var contentHeight = $(window).height() - borderHeight
          var headerHeight = $el.find('.modal-header').outerHeight() || 0
          var footerHeight = $el.find('.modal-footer').outerHeight() || 0
          var maxHeight = contentHeight - (headerHeight + footerHeight)

          $content.css({
            'overflow': 'hidden'
          })

          $el.find('.modal-body').css({
            'height': maxHeight,
            'max-height': maxHeight,
            'overflow-y': 'auto'
          })
        })
      }
    }
  },
  methods: {
    open: function () {
      this.display = true
    },
    close: function () {
      this.display = false
    },
    beforeClose: function () {
      this.$emit('beforeClose')
      return true
    },
    onShow: function () {
      this.$emit('open')
    },
    onHide: function () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">
/* ==========================================================================
   Modal styles
   ========================================================================== */
.v-modal {
  text-align: center;

  &:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  &.modal-backdrop {
    opacity: 0.87 !important;
    background: #1e1e1e;
    transition-timing-function: cubic-bezier(0.22, 0.61, 0.36, 1);
  }

  .modal-dialog {
    display: inline-block;
    min-width: 375px;
    width: auto !important;
    text-align: left;
    vertical-align: middle;
  }

  .modal-content {
    border: 0 !important;
    border-radius: 0 !important;
  }

  .modal-header {
    padding: 0;
    border-bottom: 0;

    button {
      position: absolute !important;
      right: 0px;
    }

    .close {
      width: 45px;
      height: 60px;
      color: #fff;
      opacity: 1;
      margin-top: 0;
      font: 30px/60px Arial, "Helvetica Neue", Helvetica, sans-serif;

      &:active,
      &:focus {
        box-shadow: none;
        outline: none !important;
      }
    }
  }

  .modal-title {
    background: #f29b4f;
    color: #fff;
    padding: 15px 0;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
  }

  .modal-body {
    padding: 0px;
    font-size: 16px;
  }

  .modal-footer {
    padding: 0px;
  }
}

@media only screen and (max-width: 991px) {
  .v-modal {
    &:before {
      content: none;
    }

    .modal-dialog {
      width: 100% !important;
      margin: 0 !important;
    }

    button.close {
      cursor: pointer;

      span {
        display: none;
      }

      &:after {
        content: "";
        display: inline-block;
        position: relative;
        top: -5px;
        left: 0px;
        width: 0.5em;
        height: 0.5em;
        color: #fff;
        font-size: 18px;
        border-style: solid;
        border-width: 0.22em 0.22em 0 0;
        background: transparent;
        box-sizing: content-box;
        transform: rotate(135deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/Modal.vue